import { render, staticRenderFns } from "./Titre.vue?vue&type=template&id=2fa5225c&scoped=true&"
import script from "./Titre.vue?vue&type=script&lang=js&"
export * from "./Titre.vue?vue&type=script&lang=js&"
import style0 from "./Titre.vue?vue&type=style&index=0&id=2fa5225c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5225c",
  null
  
)

export default component.exports